import { createSlice } from "@reduxjs/toolkit";
import { MEASUREMENT_VIEW } from "../constants/Constants";

const initialState = {
    measurementInProgress: false,
    measurementStatusPopup: "",
    measurementStarted: false,
    measurementView: MEASUREMENT_VIEW.OFF_VIEW,
    disabledUndoButton: false,
    showMeasurementToastPopup: false,
    measurementToastMsgStatus: null,
    isAppDownloadModalOpenForMeasurement: false,
    isFirstStepCompletedOfDownloadApp: false,
    measurementList: [],
    isMeasurementListDrawerOpen: false,
    disabledTakePhotoButton: false,
    disabledMeasurementButton: true,
};
const measurementReducerSlice = createSlice({
    name: "measurementReducer",
    initialState,
    reducers: {
        setMeasurementInProgress(state, action) {
            state.measurementInProgress = action.payload;
        },
        setMeasurementStatusPopup(state, action) {
            state.measurementStatusPopup = action.payload;
        },
        setMeasurementStarted(state, action) {
            state.measurementStarted = action.payload;
        },
        setMeasurementView(state, action) {
            state.measurementView = action.payload;
        },
        setDisableUndoButton(state, action) {
            state.disabledUndoButton = action.payload;
        },
        setShowMeasurementToastPopup(state, action) {
            state.showMeasurementToastPopup = action.payload;
        },
        setMeasurementToastMsgStatus(state, action) {
            state.measurementToastMsgStatus = action.payload;
        },
        setIsAppDownloadModalOpenForMeasurement(state, action) {
            state.isAppDownloadModalOpenForMeasurement = action.payload;
        },
        setIsFirstStepCompletedOfDownloadApp(state, action) {
            state.isFirstStepCompletedOfDownloadApp = action.payload;
        },
        setMeasurementList(state, action) {
            state.measurementList = action.payload;
        },
        setIsMeasurementListDrawerOpen(state, action) {
            state.isMeasurementListDrawerOpen = action.payload;
        },
        setDisableTakePhotoBtn(state, action) {
            state.disabledTakePhotoButton = action.payload;
        },
        setDisableMeasurementBtn(state, action) {
            state.disabledMeasurementButton = action.payload;
        },
        resetMeasurementReducer() {
            return initialState;
        },
    },
});

export const {
    setMeasurementInProgress,
    setMeasurementStatusPopup,
    setMeasurementStarted,
    setMeasurementView,
    setDisableUndoButton,
    setShowMeasurementToastPopup,
    setMeasurementToastMsgStatus,
    setIsAppDownloadModalOpenForMeasurement,
    setIsFirstStepCompletedOfDownloadApp,
    setMeasurementList,
    setIsMeasurementListDrawerOpen,
    setDisableTakePhotoBtn,
    setDisableMeasurementBtn,
    resetMeasurementReducer,
} = measurementReducerSlice.actions;
export default measurementReducerSlice.reducer;
